import React, { useEffect, useState,useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { Helmet } from "react-helmet-async";
import { useAuth } from '../../context/AuthContext';
import { query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy, getDoc, onSnapshot, updateDoc } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import { documentId } from 'firebase/firestore';

const LembarUjian = () => {
    const { user, logout } = useAuth();

    const location = useLocation();
    const datadd = location.state?.data;

    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [daftaruji, setUji] = useState({});
    const [soal, setSoal] = useState({});

    const [searchParams] = useSearchParams();
    const { kode, nama_mapel, id } = location.state || {};
    const [soalaktif, setSoalaktif] = useState([]);
    const [nosoal, setNoSoal] = useState([]);
    const [jawabansiswa, setJawabansiswa] = useState([]);
    const [loadingpilihjawaban, setLoadingPlhJawaban] = useState(false);
const [timeLeft, setTimeLeft] = useState({});
const executedRef = useRef(false); // <-- penanda sudah eksekusi atau belum

const calculateTimeLeft = () => {
    if (!daftaruji || !daftaruji?.peserta?.find((e)=>e.id===user.uid)?.waktu_mulai || !daftaruji.durasi) return { totalSeconds: 0 };

    const start = daftaruji?.peserta?.find((e)=>e.id===user.uid)?.waktu_mulai.toDate ? daftaruji?.peserta?.find((e)=>e.id===user.uid)?.waktu_mulai.toDate() : new Date(daftaruji?.peserta?.find((e)=>e.id===user.uid)?.waktu_mulai.seconds * 1000);
    const end = new Date(start.getTime() + daftaruji.durasi * 60 * 1000);
    const now = new Date();

    const difference = end - now;
    const totalSeconds = Math.max(Math.floor(difference / 1000), 0);
    return {
        totalSeconds,
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
    };
};
    useEffect(() => {
        if (!id) return;

        const unsub = onSnapshot(doc(db, "jadwal", id), (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                setUji(data);
                console.log("DATA JADWAL:", data);
            }
        });

        return () => unsub();
    }, [id]);

    async function getSoalBatch(db, ids) {
        const MAX = 30;
        const hasil = [];

        // 🔥 bagi menjadi beberapa batch
        for (let i = 0; i < ids.length; i += MAX) {
            const chunk = ids.slice(i, i + MAX);

            const q = query(
                collection(db, "soal"),
                where(documentId(), "in", chunk)
            );

            const snapshot = await getDocs(q);

            snapshot.forEach((doc) => {
                hasil.push({ id: doc.id, ...doc.data() });
            });
        }

        return hasil;
    }


    async function getJawabanSiswa(db) {
        console.log(`${user.uid}${kode}`)
        try {
            const docRef = doc(db, "jawaban", `${user.uid}${kode}`);
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                console.log("Tidak ada data jawaban");
                return;
            }

            const data = docSnap.data();
            setJawabansiswa(data)

            console.log("Jawaban siswa:", data);

        } catch (error) {
            console.log(error);
            setError(`Terjadi kesalahan: ${error.message}`);
        }
    }


    useEffect(() => {
        if (!daftaruji || !daftaruji.data) return;
        if (!kode) return;

        const du = daftaruji.data.find((p) => p.kode?.toString() === kode.toString());
        if (!du) return;

        if (!du.soal || du.soal.length === 0) return;

        const ambilSoal = async () => {
            const listSoal = await getSoalBatch(db, du.soal);
            setSoal(listSoal);
            setNoSoal(0)
            setSoalaktif(listSoal[0])
            console.log("SOAL:", listSoal);
        };

        ambilSoal();
        getJawabanSiswa(db);

    }, [daftaruji, kode]);



    const simpanJawabanFirestore = async (idSoal, idJawaban, text, jenis) => {
        try {
            const docRef = doc(db, "jawaban", user.uid + kode);
            const docSnap = await getDoc(docRef);

            const newJawabanItem = { id_jwb: idJawaban, text };

            if (docSnap.exists()) {
                const existingData = docSnap.data().data || [];
                const idxSoal = existingData.findIndex(d => d.idsoal === idSoal);

                if (idxSoal !== -1) {
                    let jawabanSoal = existingData[idxSoal].jawaban || [];

                    if (jenis === "objectif") {
                        // radio: hanya 1 jawaban → ganti jawaban lama
                        jawabanSoal = [newJawabanItem];

                    } else if (jenis === "ganda") {
                        // checkbox: toggle jawaban
                        const idxJwb = jawabanSoal.findIndex(j => j.id_jwb === idJawaban);
                        if (idxJwb !== -1) {
                            jawabanSoal.splice(idxJwb, 1); // hapus jika sudah ada
                        } else {
                            jawabanSoal.push(newJawabanItem); // tambah jika belum ada
                        }
                    } else if (jenis === "essay") {
                        jawabanSoal = [newJawabanItem];
                    }

                    console.log(jawabanSoal)

                    existingData[idxSoal].jawaban = jawabanSoal;
                    existingData[idxSoal].status = "1";
                } else {
                    // soal baru
                    existingData.push({ idsoal: idSoal, status: "1", jawaban: [newJawabanItem] });
                }

                await updateDoc(docRef, { data: existingData });
            } else {
                // dokumen baru
                await setDoc(docRef, { data: [{ idsoal: idSoal, status: 1, jawaban: [newJawabanItem] }],
                kode:kode,nama:user.nama,npsn:user.npsn,uid:user.uid,nama_mapel:nama_mapel,
                });
            }

            console.log("Jawaban berhasil disimpan ke Firestore");
        } catch (error) {
            console.error("Gagal menyimpan jawaban:", error);
        }
    };

    const daftarsoal = async () => {
        const gridHTML = soal
            .map((s, index) => {
                const sudahDijawab = jawabansiswa?.data?.find(j => j.idsoal === s.id);
                const teksJawaban = sudahDijawab?.jawaban?.[0]?.text ?? "";

                return `
                        <div 
                        class="item-soal ${sudahDijawab ? (sudahDijawab.status?.toString() === "1" ? "answered  " : "answeredragu") : ""} ${index === nosoal ? "aktif" : ""}  " 
                        data-idsoal="${s.id}"
                        data-index="${index}"
                        >
                        <div class="soal-title">Soal ${index + 1}</div>
                        <div class="jawaban-isi">${teksJawaban}</div>
                        </div>
                    `;
            })
            .join("");

        let idSoalDipilih = null;

        await Swal.fire({

            html: `<h6>DAFTAR SOAL</h6>
            </hr>
      <div class="grid-soal">
      
        ${gridHTML} 
      </div><div 
                        class="item-soal selesai" 
                        
                        >
                        <div class="soal-title ">SELESAI</div>
                        <div class="jawaban-isi"><i class="ti ti-logout"></i></div>
                        </div>
      
    `,
            showConfirmButton: false,

            // ⬇ Event delegation agar klik bisa dibaca React
            didOpen: () => {
                const popup = Swal.getPopup();

                popup.querySelector(".grid-soal")?.addEventListener("click", (e) => {
                    const item = e.target.closest(".item-soal");
                    if (!item) return;

                    // ambil ID soal
                    idSoalDipilih = item.dataset.idsoal;

                    // tandai yg dipilih
                    popup.querySelectorAll(".item-soal").forEach(i => i.classList.remove("selected"));
                    item.classList.add("selected");

                    Swal.close(); // otomatis menutup Swal
                });

                popup.querySelector(".selesai")?.addEventListener("click", async (e) => {
                    const konfirmasi = window.confirm(`Apakah Anda yakin ingin menyelesaikan Tes`);

                    if (!konfirmasi) return; // batal jika user menolak

                    try {
                        const jadwalRef = doc(db, "jadwal", id);

                        // Ambil data terbaru dari Firestore
                        const jadwalSnapshot = await getDoc(jadwalRef);

                        if (jadwalSnapshot.exists()) {
                            const jadwalData = jadwalSnapshot.data();
                            const pesertaList = Array.isArray(jadwalData.peserta) ? [...jadwalData.peserta] : [];
                            console.log(pesertaList)

                            const idx = pesertaList.findIndex(p => p.id === user.uid);

                            if (idx !== -1) {

                                pesertaList[idx] = {
                                    ...pesertaList[idx],
                                    status: "Selesai",
                                    waktuselesai: new Date()

                                }

                                // Update ke Firestore
                                await updateDoc(jadwalRef, { peserta: pesertaList });
                                window.location.href = "/Pd";
                            }
                        }
                    } catch (error) {
                        console.error(error);
                        alert("Gagal menyimpan status.");
                    }

                    Swal.close(); // otomatis menutup Swal
                });
            },

            willClose: () => {
                // setelah swal ditutup → kirim ID soal terpilih
                if (idSoalDipilih) {
                    const soalTerpilih = soal.find(s => s.id === idSoalDipilih);
                    const indesss = soal.findIndex(s => s.id === idSoalDipilih)
                    if (soalTerpilih) {
                        setNoSoal(indesss)
                        setSoalaktif(soalTerpilih); // ⬅ ganti soal aktif
                    }
                }
            }
        });
    };

    const gantisoal = async (jns) => {
        console.log(soal.length, nosoal)
        if (jns == "next") {
            if ((nosoal + 1) >= soal.length) {

            } else {
                setNoSoal(nosoal + 1)
                setSoalaktif(soal[nosoal + 1])
            }

        } else {
            if (nosoal != 0) {
                setNoSoal(nosoal - 1)
                setSoalaktif(soal[nosoal - 1])
            }



        }

    }

    const tandaisoal = async (idSoal, st) => {
        try {
            const docRef = doc(db, "jawaban", user.uid + kode);
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) return;

            const existingData = docSnap.data().data || [];

            // update status hanya untuk soal tertentu
            const newData = existingData.map(d => {
                if (d.idsoal === idSoal) {
                    return { ...d, status: st === "1" ? "2" : "1" };
                }
                return d;
            });

            await updateDoc(docRef, { data: newData });

            // update state lokal React agar UI ikut berubah
            setJawabansiswa(prev => {
                const data = Array.isArray(prev?.data) ? [...prev.data] : [];
                const idx = data.findIndex(d => d.idsoal === idSoal);

                if (idx !== -1) {
                    data[idx] = { ...data[idx], status: st === "1" ? "2" : "1" };
                } else {
                    // jika soal belum ada di state, tambahkan
                    data.push({ idsoal: idSoal, jawaban: [], status: st === "1" ? "2" : "1" });
                }

                return { data };
            });

            console.log("Status soal berhasil diupdate");
        } catch (error) {
            console.error("Gagal update status soal:", error);
        }
    };


useEffect(() => {
  if (!daftaruji || !daftaruji.waktu_mulai) return;

  const timer = setInterval(async () => {
    const t = calculateTimeLeft();
    setTimeLeft(t);

    // Jika sudah pernah dieksekusi, jangan ulangi
    if (executedRef.current) return;

    if (t.totalSeconds === 0) {
      executedRef.current = true; // <-- kunci agar hanya 1x eksekusi
      clearInterval(timer);

      try {
        const jadwalRef = doc(db, "jadwal", id);
        const jadwalSnapshot = await getDoc(jadwalRef);

        if (jadwalSnapshot.exists()) {
          const jadwalData = jadwalSnapshot.data();
          const pesertaList = Array.isArray(jadwalData.peserta) ? [...jadwalData.peserta] : [];

          const idx = pesertaList.findIndex(p => p.id === user.uid);

          if (idx !== -1) {
            pesertaList[idx] = {
              ...pesertaList[idx],
              status: "Waktu Habis",
              waktuselesai: new Date()
            };

            await updateDoc(jadwalRef, { peserta: pesertaList });
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, 1000);

  return () => clearInterval(timer);
}, [daftaruji]);



    return (

        <div>

            <Helmet>
                <title>Identifikasi Pengguna</title>
            </Helmet>


            {daftaruji?.peserta?.find((e)=>e.id===user.uid)?.status === "Waktu Habis" ? (
                <div className='pesanlembartes'>
                    <div className="inner">
                        <b>Status Tes <span className='text-danger'>{daftaruji?.peserta?.find((e)=>e.id===user.uid)?.status}</span></b>

                        <button
                            onClick={() => {  window.location.href = "/Pd"; }}
                            type="button"
                            className="btn btn-danger d-inline-flex align-items-center"
                        >
                            Keluar <i className="ti ti-logout"></i>
                        </button>

                    </div>
                </div>


            ):daftaruji?.peserta?.find((e)=>e.id===user.uid)?.status === "Dikeluarkan" ? (
                <div className='pesanlembartes'>
                    <div className="inner">
                        <b>Status Tes <span className='text-danger'>{daftaruji.status}</span></b>

                        <button
                            onClick={() => {  window.location.href = "/Pd"; }}
                            type="button"
                            className="btn btn-danger d-inline-flex align-items-center"
                        >
                            Keluar <i className="ti ti-logout"></i>
                        </button>

                    </div>
                </div>


            ):daftaruji.status === "Selesai" ? (
                <div className='pesanlembartes'>
                    <div className="inner">
                        <b>Status Tes sudah <span className='text-danger'>{daftaruji.status}</span></b>

                        <button
                            onClick={() => {  window.location.href = "/Pd"; }}
                            type="button"
                            className="btn btn-danger d-inline-flex align-items-center"
                        >
                            Keluar <i className="ti ti-logout"></i>
                        </button>

                    </div>
                </div>


            ) : daftaruji.status === "Aktif" ? (

                
                <>
                    <nav className="navbar navbar-expand-lg navbar-light  fixed-top" style={{ backgroundColor: "#e3f2fd" }}>
                        <div className="container-fluid">
                            <a className="navbar-brand" href="#" style={{ textTransform: "capitalize" }}>Hi.{user.nama} | {timeLeft.hours?.toString().padStart(2, '0')}:
    {timeLeft.minutes?.toString().padStart(2, '0')}:
    {timeLeft.seconds?.toString().padStart(2, '0')}</a>


                            <div className='btn-group'>
                              
                                <button type="button" className="btn btn-secondary d-inline-flex align-items-center text-white">SOAL <b>{nosoal + 1}</b></button>
                                <button type="button" onClick={() => daftarsoal()} className="btn btn-primary d-inline-flex align-items-center text-white"><i className="ti ti-grid-dots"></i> <b>DAFTAR</b></button>
                                <button onClick={() => { gantisoal("priview") }} type="button" className="btn btn-success d-inline-flex align-items-center"><i className="ti ti-chevron-left"></i> Kembalinya</button>
                                <button onClick={() => { gantisoal("next") }} type="button" className="btn btn-danger d-inline-flex align-items-center"> Berikutnya <i className="ti ti-chevron-right"></i></button>

                            </div>

                        </div>
                    </nav>
                    <div className="pc-container" style={{ backgroundColor: "#d1c4e9" }}>
                        <div className="pc-content" >
                            <div className="page-header">
                                <div className="page-block">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <div className="page-header-title"><h5 className="m-b-10">Tab Layout</h5></div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="card m-2">
                                <h5 className="card-header"><button type="button" className="btn btn-secondary d-inline-flex align-items-center text-white">SOAL <b>{nosoal + 1}</b> {jawabansiswa.data?.find(d => d.idsoal === soalaktif.id)?.status}</button>
                                    <button onClick={() => { tandaisoal(soalaktif.id, jawabansiswa.data?.find(d => d.idsoal === soalaktif.id)?.status) }} type="button" className={`btn ${jawabansiswa.data?.find(d => d.idsoal === soalaktif.id)?.status === "1" ? "btn-success" : "btn-warning "} d-inline-flex align-items-center`}><i className={`ti ${jawabansiswa.data?.find(d => d.idsoal === soalaktif.id)?.status === "1" ? "ti-pinned-off" : "ti-pinned "}`}></i> Tandai</button>
                                </h5>

                                <div className="card-body">
                                    <p dangerouslySetInnerHTML={{ __html: soalaktif.soal || "-" }}></p>
                                    <hr />
                                    <span style={{ textTransform: "capitalize" }}>Jawaban <b>{soalaktif.jenis}</b></span>
                                    <hr />
                                    {soalaktif.jenis === "essay" ? (
                                        <p>
                                            <textarea
                                                id={`essay-${soalaktif.id}`} // unique id per soal
                                                className="form-control"
                                                defaultValue={jawabansiswa.data?.find(d => d.idsoal === soalaktif.id)?.jawaban?.[0]?.text || ""}
                                            ></textarea>

                                            <button
                                                type="button"
                                                onClick={() => {
                                                    // ambil langsung value dari textarea via ID
                                                    const text = document.getElementById(`essay-${soalaktif.id}`).value;

                                                    setJawabansiswa(prev => {
                                                        const data = Array.isArray(prev?.data) ? [...prev.data] : [];
                                                        const idx = data.findIndex(d => d.idsoal === soalaktif.id);

                                                        if (idx !== -1) {
                                                            if (!data[idx].jawaban) data[idx].jawaban = [];
                                                            if (!data[idx].jawaban[0]) data[idx].jawaban[0] = {};
                                                            data[idx].jawaban[0].text = text;
                                                        } else {
                                                            data.push({ idsoal: soalaktif.id, jawaban: [{ text }] });
                                                        }

                                                        // simpan ke Firestore
                                                        simpanJawabanFirestore(soalaktif.id, [], text, soalaktif.jenis);
                                                        return { data };
                                                    });
                                                }}
                                                className="btn btn-primary d-inline-flex align-items-center text-white"
                                            >
                                                <i className="ti ti-grid-dots"></i> <b>Simpan</b>
                                            </button>
                                        </p>

                                    ) : (
                                        <ul className="list-group list-group-flush">
                                            {soalaktif?.jawaban?.map((jawabItem, index) => {
                                                const jawabansisaplh = jawabansiswa?.data?.find(j => j.idsoal === soalaktif.id);
                                                const jawabansesuai = jawabansisaplh?.jawaban?.some(jw => jw.id_jwb?.toString() === jawabItem.id_jwb?.toString());

                                                return (
                                                    <li key={index} className="list-group-item px-0">
                                                        <div className="d-flex align-items-center">
                                                            <div className="flex-shrink-0">
                                                                <div
                                                                    className={`avtar avtar-s border ${jawabansesuai
                                                                        ? jawabansisaplh?.status?.toString() === "1"
                                                                            ? "bg-success"
                                                                            : jawabansisaplh?.status?.toString() === "2"
                                                                                ? "bg-warning"
                                                                                : "bg-secondary"
                                                                        : "bg-secondary"
                                                                        }`}
                                                                >
                                                                    {soalaktif.jenis === "objectif" ? (
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name={soalaktif.id}
                                                                            checked={jawabansiswa.data?.some(
                                                                                d => d.idsoal === soalaktif.id && d.jawaban[0]?.id_jwb === jawabItem.id_jwb
                                                                            ) || false}
                                                                            onChange={() => {
                                                                                const newItem = {
                                                                                    idsoal: soalaktif.id,
                                                                                    jawaban: [{ id_jwb: jawabItem.id_jwb, text: jawabItem.text }]
                                                                                };

                                                                                setJawabansiswa(prev => {
                                                                                    const data = Array.isArray(prev?.data) ? [...prev.data] : [];
                                                                                    const idx = data.findIndex(d => d.idsoal === soalaktif.id);

                                                                                    if (idx !== -1) {
                                                                                        data[idx] = { ...data[idx], ...newItem };
                                                                                    } else {
                                                                                        data.push(newItem);
                                                                                    }

                                                                                    simpanJawabanFirestore(soalaktif.id, jawabItem.id_jwb, jawabItem.text, soalaktif.jenis);
                                                                                    return { data };
                                                                                });
                                                                            }}
                                                                        />
                                                                    ) : soalaktif.jenis === "ganda" ? (
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={jawabansiswa.data?.some(
                                                                                d =>
                                                                                    d.idsoal === soalaktif.id &&
                                                                                    d.jawaban.some(j => j.id_jwb === jawabItem.id_jwb)
                                                                            ) || false}
                                                                            onChange={(e) => {
                                                                                const checked = e.target.checked;

                                                                                setJawabansiswa(prev => {
                                                                                    const data = Array.isArray(prev?.data) ? [...prev.data] : [];
                                                                                    const idx = data.findIndex(d => d.idsoal === soalaktif.id);

                                                                                    const newJawaban = {
                                                                                        id_jwb: jawabItem.id_jwb,
                                                                                        text: jawabItem.text || "",
                                                                                        status: "1"
                                                                                    };

                                                                                    if (idx !== -1) {
                                                                                        let jawabanLama = data[idx].jawaban || [];
                                                                                        if (checked) {
                                                                                            if (!jawabanLama.some(j => j.id_jwb === newJawaban.id_jwb)) {
                                                                                                jawabanLama.push(newJawaban);
                                                                                            }
                                                                                        } else {
                                                                                            jawabanLama = jawabanLama.filter(j => j.id_jwb !== newJawaban.id_jwb);
                                                                                        }
                                                                                        data[idx] = { ...data[idx], jawaban: jawabanLama };
                                                                                    } else if (checked) {
                                                                                        data.push({ idsoal: soalaktif.id, jawaban: [newJawaban] });
                                                                                    }

                                                                                    simpanJawabanFirestore(soalaktif.id, jawabItem.id_jwb, jawabItem.text, soalaktif.jenis);
                                                                                    return { data };
                                                                                });
                                                                            }}
                                                                        />
                                                                    ) : null}
                                                                </div>
                                                            </div>

                                                         <div
  className="flex-grow-1 ms-3"
  dangerouslySetInnerHTML={{ __html: jawabItem.text }}
></div>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>) : (null)}
        </div>
    );
};

export default LembarUjian;
